import { useCachedNetwork } from '@tribeplatform/react-sdk/hooks';
import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getNetworkKey } from '../../utils/keys';
export const useNetwork = (options) => {
    const { useQueryOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const networkKey = getNetworkKey({ fields });
    return useQuery(networkKey, () => client.network.get(fields), {
        placeholderData: useCachedNetwork(),
        ...useQueryOptions,
    });
};
//# sourceMappingURL=useNetwork.js.map